module.exports = __webpack_public_path__ + "static/media/save-svgrepo-com (2).e8347062.svg";